{
  "familyId": "STU-KAART",
  "questions": [
    {
      "id": "STU-KAART-001",
      "familyId": "STU-KAART",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kaartlezen",
      "subSkill": "kaart_legenda_route",
      "questionType": "multiple_choice",
      "question": "Op een plattegrond staat een schaal van 1 : 5.000. Een straat is op de plattegrond 4 cm lang. Hoe lang is de straat in werkelijkheid?",
      "context": null,
      "options": ["200 meter", "20 meter", "2.000 meter", "50 meter"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "rule",
          "data": {
            "title": "Kaartschaal 1 : 5.000",
            "content": "Schaal 1 : 5.000 betekent: 1 cm op de kaart = 5.000 cm in werkelijkheid. De straat is 4 cm op de kaart.",
            "icon": "map"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kaartschaal berekenen",
            "content": "Schaal 1:5.000 betekent: 1 cm op de kaart = 5.000 cm in werkelijkheid. Bereken: 4 cm × 5.000 = 20.000 cm = 200 meter.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "map_scale_reading",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Schaal 1 : 5.000 betekent dat 1 cm op de kaart gelijk is aan 5.000 cm in werkelijkheid. De straat is 4 cm op de kaart, dus: 4 × 5.000 = 20.000 cm = 200 meter.",
        "solutionSteps": [
          "Lees de schaal af: 1:5.000 betekent 1 cm op de kaart = 5.000 cm in het echt",
          "Vermenigvuldig de kaartafstand met de schaal: 4 × 5.000 = 20.000 cm",
          "Reken om naar meter: 20.000 ÷ 100 = 200 meter"
        ],
        "distractorExplanations": {
          "0": "Correct! De straat is 200 meter lang (4 × 5.000 = 20.000 cm = 200 m).",
          "1": "20 meter is te kort. Je hebt waarschijnlijk maar 1 cm vermenigvuldigd in plaats van 4 cm.",
          "2": "2.000 meter is te lang. Je bent vergeten om cm om te rekenen naar meter (20.000 cm ÷ 100 = 200 m).",
          "3": "50 meter klopt niet. De berekening is: 4 cm × 5.000 = 20.000 cm = 200 meter."
        }
      }
    },
    {
      "id": "STU-KAART-002",
      "familyId": "STU-KAART",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kaartlezen",
      "subSkill": "kaart_legenda_route",
      "questionType": "multiple_choice",
      "question": "Op een kaart staat een schaal van 1 : 10.000. Twee steden liggen 3 cm van elkaar op de kaart. Hoe ver liggen ze in werkelijkheid uit elkaar?",
      "context": null,
      "options": ["300 meter", "30 meter", "3.000 meter", "3 kilometer"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "rule",
          "data": {
            "title": "Kaartschaal 1 : 10.000",
            "content": "Schaal 1 : 10.000 betekent: 1 cm op de kaart = 10.000 cm in werkelijkheid. De afstand op de kaart is 3 cm.",
            "icon": "map"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kaartschaal berekenen",
            "content": "Schaal 1:10.000 betekent: 1 cm op de kaart = 10.000 cm in werkelijkheid. Bereken: 3 cm × 10.000 = 30.000 cm = 300 meter.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "map_scale_reading",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Schaal 1 : 10.000 betekent dat 1 cm op de kaart gelijk is aan 10.000 cm in werkelijkheid. De afstand is 3 cm op de kaart, dus: 3 × 10.000 = 30.000 cm = 300 meter.",
        "solutionSteps": [
          "Lees de schaal af: 1:10.000 betekent 1 cm op de kaart = 10.000 cm in het echt",
          "Vermenigvuldig de kaartafstand met de schaal: 3 × 10.000 = 30.000 cm",
          "Reken om naar meter: 30.000 ÷ 100 = 300 meter"
        ],
        "distractorExplanations": {
          "0": "Correct! De afstand is 300 meter (3 × 10.000 = 30.000 cm = 300 m).",
          "1": "30 meter is te kort. Je hebt waarschijnlijk maar 1 cm vermenigvuldigd in plaats van 3 cm.",
          "2": "3.000 meter is te lang. Je bent vergeten om cm om te rekenen naar meter.",
          "3": "3 kilometer = 3.000 meter, dat is te lang. De juiste berekening geeft 300 meter."
        }
      }
    },
    {
      "id": "STU-KAART-003",
      "familyId": "STU-KAART",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kaartlezen",
      "subSkill": "kaart_legenda_route",
      "questionType": "multiple_choice",
      "question": "Op een kaart zie je deze symbolen in de legenda: een blauw vlak = water, een groen vlak = bos, een bruin driehoekje = berg. Wat betekent een bruin driehoekje op de kaart?",
      "context": null,
      "options": ["Daar ligt een berg.", "Daar is een bos.", "Daar is water.", "Daar is een stad."],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "rule",
          "data": {
            "title": "Legenda",
            "content": "Blauw vlak = water | Groen vlak = bos | Bruin driehoekje = berg",
            "icon": "map"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Legenda lezen",
            "content": "De legenda is het 'woordenboek' van een kaart. Elk symbool heeft een vaste betekenis. Kijk in de legenda: bruin driehoekje = berg.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "map_legend_reading",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "De legenda vertelt wat elk symbool op de kaart betekent. Volgens de legenda staat een bruin driehoekje voor een berg. De legenda is het 'woordenboek' van de kaart — altijd eerst de legenda raadplegen!",
        "distractorExplanations": {
          "0": "Correct! Volgens de legenda staat een bruin driehoekje voor een berg.",
          "1": "Een bos wordt aangegeven met een groen vlak, niet met een bruin driehoekje.",
          "2": "Water wordt aangegeven met een blauw vlak, niet met een bruin driehoekje.",
          "3": "Een stad staat niet in deze legenda. Het bruine driehoekje staat voor een berg."
        }
      }
    },
    {
      "id": "STU-KAART-004",
      "familyId": "STU-KAART",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kaartlezen",
      "subSkill": "kaart_legenda_route",
      "questionType": "multiple_choice",
      "question": "Op een wegenkaart met schaal 1 : 50.000 meet je een afstand van 6 cm tussen twee dorpen. Hoe ver is dat in werkelijkheid?",
      "context": null,
      "options": ["3 kilometer", "300 meter", "30 kilometer", "6 kilometer"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "rule",
          "data": {
            "title": "Kaartschaal 1 : 50.000",
            "content": "Schaal 1 : 50.000 betekent: 1 cm op de kaart = 50.000 cm = 500 meter in werkelijkheid. De afstand op de kaart is 6 cm.",
            "icon": "map"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Schaal omrekenen",
            "content": "Schaal 1:50.000 betekent: 1 cm = 50.000 cm = 500 meter. Dus 6 cm = 6 × 500 = 3.000 meter = 3 kilometer.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "map_scale_larger",
      "variantIndex": 4,
      "feedback": {
        "explanationText": "Schaal 1 : 50.000 betekent dat 1 cm op de kaart = 50.000 cm = 500 meter in werkelijkheid. De afstand is 6 cm, dus: 6 × 500 = 3.000 meter = 3 kilometer.",
        "solutionSteps": [
          "Schaal 1:50.000 → 1 cm = 50.000 cm",
          "Reken om: 50.000 cm = 500 meter",
          "Vermenigvuldig: 6 × 500 = 3.000 meter = 3 km"
        ],
        "distractorExplanations": {
          "0": "Correct! 6 cm × 50.000 = 300.000 cm = 3.000 m = 3 km.",
          "1": "300 meter is te kort. Je hebt waarschijnlijk maar 1 cm vermenigvuldigd of een rekenfout gemaakt.",
          "2": "30 kilometer is te lang. Controleer je berekening: 6 × 50.000 = 300.000 cm = 3.000 m = 3 km.",
          "3": "6 kilometer klopt niet. De berekening is: 6 × 50.000 = 300.000 cm = 3.000 m = 3 km."
        }
      }
    },
    {
      "id": "STU-KAART-005",
      "familyId": "STU-KAART",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kaartlezen",
      "subSkill": "kaart_legenda_route",
      "questionType": "multiple_choice",
      "question": "Je bekijkt een kaart van een natuurgebied. De legenda toont: stippellijn = wandelpad, doorgetrokken lijn = fietspad, dubbele lijn = autoweg. Welk pad mag je NIET met de auto gebruiken?",
      "context": null,
      "options": [
        "Het wandelpad en het fietspad.",
        "Alleen het wandelpad.",
        "Alleen het fietspad.",
        "Alle paden mogen met de auto."
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "rule",
          "data": {
            "title": "Legenda",
            "content": "Stippellijn = wandelpad | Doorgetrokken lijn = fietspad | Dubbele lijn = autoweg",
            "icon": "map"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Legenda interpreteren",
            "content": "De legenda geeft aan welk type weg elk symbool voorstelt. Een autoweg (dubbele lijn) is voor auto's. Een wandelpad (stippellijn) en fietspad (doorgetrokken lijn) zijn niet voor auto's.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "map_legend_interpret",
      "variantIndex": 5,
      "feedback": {
        "explanationText": "Volgens de legenda is alleen de dubbele lijn een autoweg. Het wandelpad (stippellijn) en het fietspad (doorgetrokken lijn) zijn niet bedoeld voor auto's. Je mag dus met de auto alleen de autoweg gebruiken.",
        "distractorExplanations": {
          "0": "Correct! Zowel het wandelpad als het fietspad zijn niet voor auto's — alleen de autoweg (dubbele lijn) is voor auto's.",
          "1": "Niet alleen het wandelpad, maar ook het fietspad is niet voor auto's. Beide zijn verboden voor auto's.",
          "2": "Niet alleen het fietspad, maar ook het wandelpad is niet voor auto's. Beide zijn verboden voor auto's.",
          "3": "Niet alle paden mogen met de auto. Alleen de autoweg (dubbele lijn) is voor auto's."
        }
      }
    }
  ]
}
